import React, { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  Outlet,
} from "react-router-dom";
import { I18nProvider, SUPPORTED_LANGS, DEFAULT_LANG, useI18n } from "@/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";

function MetaBinder() {
  const { lang, t } = useI18n();
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.lang = lang;
    const title = t("meta.title");
    const description = t("meta.description");
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector("meta[name='description']");
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  }, [lang, t]);
  return null;
}

function LangShell() {
  return (
    <>
      <MetaBinder />
      <Header />
      <Outlet />
      <Footer />
      <CookieBanner />
    </>
  );
}

function LangLayout() {
  const { lang } = useParams();
  const active = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }
  return (
    <I18nProvider lang={active}>
      <LangShell />
    </I18nProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
          <Route path="/thank_you" element={<ThankYou />} />
          <Route path="/:lang" element={<LangLayout />}>
            <Route index element={<Home />} />
            <Route path="privacy" element={<LegalPage ns="privacy" />} />
            <Route path="cookies" element={<LegalPage ns="cookiePolicy" />} />
            <Route path="terms" element={<LegalPage ns="terms" />} />
          </Route>
          <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
